import Icon from '@mdi/react';
import { Avatar } from '@mui/material';
import { mdiCogOutline } from '@mdi/js';

export const PartnerSettingsAvatar = () => (
  <Avatar>
    <Icon path={mdiCogOutline} size={1} />
  </Avatar>
);
